import { render, staticRenderFns } from "./informationCard.vue?vue&type=template&id=3ae16b30&scoped=true"
import script from "./informationCard.vue?vue&type=script&lang=js"
export * from "./informationCard.vue?vue&type=script&lang=js"
import style0 from "./informationCard.vue?vue&type=style&index=0&id=3ae16b30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae16b30",
  null
  
)

export default component.exports